import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from 'react';
import { Link, StaticQuery } from 'gatsby';
import { Fragment } from 'react';
export var Navbar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Navbar, _React$Component);

  function Navbar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.toggleHamburger = function () {
      // toggle the active boolean in the state
      _this.setState({
        active: !_this.state.active
      }, // after state has been updated,
      function () {
        // set the class in state for the navbar accordingly
        _this.state.active ? _this.setState({
          navBarActiveClass: 'is-active'
        }) : _this.setState({
          navBarActiveClass: ''
        });
      });
    };

    _this.state = {
      active: false,
      navBarActiveClass: ''
    };
    return _this;
  }

  var _proto = Navbar.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return /*#__PURE__*/React.createElement(StaticQuery, {
      render: function render(_ref) {
        var navbar = _ref.site.siteMetadata.navbar;
        return /*#__PURE__*/React.createElement("nav", {
          className: "navbar " + navbar.className,
          role: "navigation",
          "aria-label": "main-navigation"
        }, /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "navbar-brand"
        }, /*#__PURE__*/React.createElement(Link, {
          to: "/",
          className: "navbar-item",
          title: "Logo"
        }, /*#__PURE__*/React.createElement("img", {
          src: navbar.logo.file,
          alt: navbar.logo.alt,
          style: {
            width: navbar.logo.width
          }
        })), /*#__PURE__*/React.createElement("div", {
          className: "navbar-burger burger " + _this2.state.navBarActiveClass,
          "data-target": "navMenu",
          onClick: function onClick() {
            return _this2.toggleHamburger();
          }
        }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("span", null))), /*#__PURE__*/React.createElement("div", {
          id: "navMenu",
          className: "navbar-menu " + _this2.state.navBarActiveClass
        }, /*#__PURE__*/React.createElement("div", {
          className: "navbar-start has-text-centered"
        }, /*#__PURE__*/React.createElement(ShowMenuItems, {
          items: navbar.menuItems
        })))));
      },
      query: "631054207"
    });
  };

  return Navbar;
}(React.Component);
export var ShowMenuItems = function ShowMenuItems(_ref2) {
  var items = _ref2.items,
      _ref2$asListItem = _ref2.asListItem,
      asListItem = _ref2$asListItem === void 0 ? false : _ref2$asListItem;

  var itemElement = function itemElement(menuItem) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, menuItem.href && (menuItem.href.indexOf('http') >= 0 ? /*#__PURE__*/React.createElement("a", {
      className: "navbar-item",
      href: menuItem.href,
      target: "_blank"
    }, menuItem.content) : /*#__PURE__*/React.createElement(Link, {
      className: "navbar-item",
      to: menuItem.href
    }, menuItem.content)), !menuItem.href && /*#__PURE__*/React.createElement("p", {
      className: "navbar-item"
    }));
  };

  return items.map(function (menuItem, i) {
    if (asListItem) {
      return /*#__PURE__*/React.createElement("li", {
        key: menuItem.href || i
      }, itemElement(menuItem));
    } else {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: menuItem.href || i
      }, itemElement(menuItem));
    }
  });
};